module.exports = __webpack_public_path__ + "static/media/7.1a97803c.JPG";